const GetFamilyName = (familyId, families) => {
    const family = families.find(f => f.id === familyId);
    return family ? family.familyName : "No Family";
};

export default GetFamilyName;